<template>
  <div>
    <Month 
      v-if="type === 'month'"
      :date="date"
      :spec_slug="specSlug"
      :company="company"
      :services="specInfo.service"
      :specialist="specInfo"
       />
    <div v-else-if="type === 'week'">
      <ScheduleAdmin
        ref="calendar"
        v-if="specSlug !== '' && company.id > 0"
        :services="specInfo.service"
        :slug="specSlug"
        :specialist="specInfo"
        :startDate="firstDay"
        :current_org="[company.id]"
      />
    </div>
    <div v-else-if="type === 'day'">
      <Day />
    </div>
  </div>
</template>

<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import { mapActions, mapState } from "vuex";

import { Month, Day } from "@/components/Scheduler";
import ScheduleAdmin from "@/components/ScheduleAdmin";

@Component({
  components: {
    Day,
    Month,
    ScheduleAdmin
  },
  methods: mapActions(["getScheduleByMonth", "getReservationsByMonth"])
})
export default class Scheduler extends Vue {
  @Prop() type;
  @Prop() specSlug;
  @Prop() specInfo;
  @Prop() company;
  @Prop() firstDay;
  @Prop() date;

  mounted() {
  }
}
</script>

<style lang="stylus" scoped></style>